import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { Employee } from '../../types/Employee/Employee'
import { StyledTableCell } from '../core/StyledTableCell'
import { AgentRow } from './QCAgentRow'

type SelectQCProps = {
	agents: Employee[] | undefined
}

export function SelectQCList({ agents }: SelectQCProps) {
	return (
		<>
			<TableContainer sx={{ height: '100%', width: '100%', overflowX: 'scroll' }}>
				<Table stickyHeader>
					<TableHead>
						<TableRow>
							<StyledTableCell align='left'>Name</StyledTableCell>
							<StyledTableCell align='center'>Employee Id</StyledTableCell>
							<StyledTableCell align='center'>Primary Craft</StyledTableCell>
							<StyledTableCell align='center'>Worker Class</StyledTableCell>
							<StyledTableCell align='center'>Status</StyledTableCell>
						</TableRow>
					</TableHead>

					<TableBody>
						{(agents ?? []).map((a: Employee) => (
							<AgentRow agent={a} key={a.id} />
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	)
}
